<template>
  <div class="token-selector">
    <div v-if="loadingTokens" class="d-flex align-items-center justify-content-center py-3 gap-2">
      <div class="spinner-border spinner-border-sm spinner-teal"></div>
      <span class="text-sm text-secondary">Carregando tokens...</span>
    </div>
    <div v-else-if="tokens.length === 0" class="text-center text-secondary py-3">
      <i class="fas fa-coins mb-2" style="font-size:1.5rem; color:#cbd5e0;"></i>
      <p class="mb-0 text-sm">Nenhum token disponível</p>
    </div>
    <div v-else class="tokens-list">
      <label
        v-for="t in tokens"
        :key="t.id"
        class="token-row"
        :class="{ 'token-row--selected': modelValue === t }"
      >
        <input
          type="radio"
          :value="t"
          :checked="modelValue === t"
          class="token-radio"
          @change="$emit('update:modelValue', t)"
        />
        <span class="token-name">{{ t.token }}</span>
        <span class="token-qty">{{ t.usage_count }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import { API_ENDPOINTS, apiRequest, handleApiResponse } from '@/config/api';

export default {
  name: 'TokenSelector',
  props: {
    modelValue: {
      type: Object,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      tokens: [],
      loadingTokens: false,
    };
  },
  mounted() {
    this.loadTokens();
  },
  methods: {
    async loadTokens() {
      this.loadingTokens = true;
      this.tokens = [];
      this.$emit('update:modelValue', null);
      try {
        const response = await apiRequest(API_ENDPOINTS.TOKENS);
        const data = await handleApiResponse(response);
        this.tokens = Array.isArray(data) ? data
          : Array.isArray(data?.data) ? data.data
          : Array.isArray(data?.tokens) ? data.tokens
          : [];
      } catch (err) {
        console.error('Erro ao carregar tokens:', err.message);
      } finally {
        this.loadingTokens = false;
      }
    },
  },
};
</script>

<style scoped>
/* ── Tokens list ── */
.tokens-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.token-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  background: #f7fafc;
  border: 1.5px solid #eef0f4;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}

.token-row:hover {
  border-color: rgba(23,193,232,0.4);
  background: rgba(23,193,232,0.04);
}

.token-row--selected {
  border-color: #17c1e8;
  background: rgba(23,193,232,0.08);
}

.token-radio {
  accent-color: #17c1e8;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  cursor: pointer;
}

.token-name {
  flex: 1;
  font-size: 0.82rem;
  font-weight: 600;
  color: #344767;
}

.token-qty {
  font-size: 0.82rem;
  font-weight: 800;
  color: #17c1e8;
  background: rgba(23,193,232,0.08);
  border-radius: 20px;
  padding: 2px 12px;
  min-width: 48px;
  text-align: center;
}

.spinner-teal {
  color: #17c1e8;
}
</style>
